import React from 'react'
import ModalWrapper from '../ModalWrapper'
import AppleAccountAuthenticationContainer from '../../../containers/account/AppleAccountAuthenticationContainer'

const AppleAccountAuthenticationModal= props => {


	return (
		<div className='accountAuthentication-modal'>
			<ModalWrapper
				{...props}
				title={(props.data ? 'Add Apple Sign-in' : 'Apple Sign-in')}
				iconName='appleSignInLogo'
				modalStyle='light'
				closeBtn={false}
			>
			<AppleAccountAuthenticationContainer {...props} />
	</ModalWrapper>
	</div>
	)
}

export default AppleAccountAuthenticationModal